import throttle from "lodash/throttle";

const Header = () => {

	var userAgent = window.navigator.userAgent;
	if((userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) && userAgent.match(/Version\/10/)) {
		document.querySelector('html').classList.add('ios-safari-10');
	}

	// for mouse devices keep the second level navigation open
	// const mainNavItems = Array.from(document.querySelectorAll('.main-nav .nav-link'));
	// function onMainNaviItemMouseEnter(e) {
	// 	if(e.target && e.target.matches('.nav-link')) {
	// 		e.target.classList.add('hover');
	// 	}
	// }
	// function onMainNaviItemMouseOut(e) {
	// 	if(e.target && e.target.matches('.nav-link')) {
	// 		e.target.classList.remove('hover');
	// 	}
	// }
	// mainNavItems.forEach(item => {
	// 	item.addEventListener('mouseenter', onMainNaviItemMouseEnter);
	// 	item.addEventListener('mouseout', throttle(onMainNaviItemMouseOut, 500));
	// });

	const toggleBtn = document.querySelector('.toggle-main-nav');
	if (toggleBtn) {
		toggleBtn.addEventListener("click", (event) => {
			if (toggleBtn.classList.contains("is-active")) {
				toggleBtn.classList.remove("is-active");
				document.documentElement.classList.remove("main-nav-open");
			} else {
				toggleBtn.classList.add("is-active");
				setTimeout(() => {
					document.documentElement.classList.add("main-nav-open");
				}, 200);
			}
		});
	}

	// mobile main menu navigation
	let maxWidthForMobile = 962 - 1; // needs to match $container-max-widths: xl in Ems.Site/Resources/Private/Components/Variables/Layout.scss

	if (document.querySelector('.main-nav')) {
		document.querySelector('.main-nav').addEventListener('click', (e) => {
			var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
			if (viewportWidth > maxWidthForMobile) {
				return;
			}

			// back to parent
			let navItem = false;
			if (e.target.classList.contains('nav-link') && e.target.parentNode.classList.contains('back-to-parent')) {
				navItem = e.target.parentNode;
			}
			if (e.target.classList.contains('back-to-parent')) {
				navItem = e.target;
			}
			if (navItem) {
				navItem.parentNode.parentNode.classList.remove('mobile-open');
				return;
			}


			// item with submenu
			navItem = false;
			if (e.target.classList.contains('nav-link')) {
				navItem = e.target.parentNode;
			}
			if (e.target.classList.contains('nav-item')) {
				navItem = e.target;
			}
			if (!navItem) {
				return; // the container was clicked
			}

			let list = navItem.querySelector('ul');
			if (list) {
				// there is a subnavigation, open it
				e.preventDefault();
				navItem.classList.add('mobile-open');

				// add a back to parent link
				if (!navItem.querySelector('.back-to-parent')) {
					let label = document.querySelector('.main-nav').dataset.backToParent;
					let link = '<li class="nav-item layout-horizontal back-to-parent"><a class="nav-link">' + label + '</a></li>';
					list.innerHTML = link + list.innerHTML;
				}
			}
		});
	}
};

export default Header;
